import { useFlag, useVariant } from '@cognite/react-feature-flags';
import { captureException } from '@sentry/browser';
import { createContext, useContext } from 'react';

export interface UseIsLocationEnabledForFeatureFlagContextInterface {
  useVariant: typeof useVariant;
  useFlag: typeof useFlag;
  captureException: typeof captureException;
}

export const IsLocationEnabledForFeatureFlagContext =
  createContext<UseIsLocationEnabledForFeatureFlagContextInterface>({
    useVariant,
    useFlag,
    captureException,
  });

export const useIsLocationEnabledContext =
  (): UseIsLocationEnabledForFeatureFlagContextInterface => {
    return useContext(IsLocationEnabledForFeatureFlagContext);
  };
